/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerAssessChangeMutationResponse, ComparisonsControllerAssessChangePathParams, ComparisonsControllerAssessChange400, ComparisonsControllerAssessChange401, ComparisonsControllerAssessChange403, ComparisonsControllerAssessChange404 } from "../../models/comparisonsController/ComparisonsControllerAssessChange";

function getComparisonsControllerAssessChangeUrl(id: ComparisonsControllerAssessChangePathParams["id"], changeId: ComparisonsControllerAssessChangePathParams["changeId"]) {
  const res = { method: 'POST', url: `/api/v1/comparisons/${id}/changes/${changeId}/assessments` as const }  
  return res
}

/**
 * @summary Accept or reject a comparison change
 * {@link /api/v1/comparisons/:id/changes/:changeId/assessments}
 */
export async function comparisonsControllerAssessChange(id: ComparisonsControllerAssessChangePathParams["id"], changeId: ComparisonsControllerAssessChangePathParams["changeId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ComparisonsControllerAssessChangeMutationResponse, ResponseErrorConfig<ComparisonsControllerAssessChange400 | ComparisonsControllerAssessChange401 | ComparisonsControllerAssessChange403 | ComparisonsControllerAssessChange404>, unknown>({ method : "POST", url : getComparisonsControllerAssessChangeUrl(id, changeId).url.toString(), ... requestConfig })  
  return res.data
}